import { Col } from 'antd';
import { isEmpty } from 'lodash';
import { Color } from 'src/styles';
import { v4 as uuidv4 } from 'uuid';

import { MTypography } from '../../MTypography/MTypography';

import * as Styles from './MyAccountProgressBar.styles';

export interface MyAccountProgressBarProps {
  steps?: { isComplete: boolean }[];
}

export const MyAccountProgressBar = ({ steps = [] }: MyAccountProgressBarProps) => {
  const completedSteps = steps.filter(aMenuItem => aMenuItem.isComplete);

  return (
    <Col span={22} className={Styles.progressBarContainer}>
      {isEmpty(steps) ? null : (
        <>
          <div className={Styles.stepsContaienr}>
            {steps.map(aStep => (
              <div key={uuidv4()} className={Styles.step({ isComplete: aStep.isComplete })} />
            ))}
          </div>
          <MTypography variant='body1' color={Color.Gray7}>
            {completedSteps.length}/{steps.length} Steps Completed
          </MTypography>
        </>
      )}
    </Col>
  );
};
